import React, { useEffect, useState } from 'react'
import PageTitleBanner from './Common/PageTitleBanner'
import { NOTEBOOKURL } from '../Config'

const Infrastructure = () => {
  const [data, setData] = useState([])
  useEffect(() => {
    getInfrastructureData()
  }, [])


  const getInfrastructureData = async () => {
    const res = await fetch(`${NOTEBOOKURL}InfrastructureQuality/GetInfrastructureQuality`, {
      method: "post",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        "InfrastructureAndQualityID": "",
        "Type": "Infrastructure & Facilities",
        "StartDate": "",
        "EndDate": "",
        "PaginationID": "-1",
        "PageLength": ""
      })
    })
    const result = await res.json()


    setData(result.data)

  }
  return (
    <>
      <PageTitleBanner title={"Infrastructure And Facilities"} />
      <div id="content" className="site-content">
        <div className="container">
          <div className="row">
            <div id="primary" className="content-area">
              <div className="site-main">
                {data?.map((element, index) => (
                  <div key={index} style={{ margin: "0px 0px" }} className="single-project row">
                    <div className="project-content col-md-12 col-sm-12 col-xs-12">
                      <h2 className="single-project-title">{element.Title}</h2>
                      <blockquote className='text-justify'>{element.Description}</blockquote>
                    </div>
                  </div>
                ))}

              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default Infrastructure